import { io, type Socket } from 'socket.io-client';
import { getAuthToken } from './session';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? 'https://server.support.carewinners.com/api/v1';
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL ?? API_BASE_URL.replace(/\/api\/v1$/, '');

let socket: Socket | null = null;

const buildSocket = (): Socket => {
  const token = getAuthToken();

  const namespaceUrl = `${SOCKET_URL}/chat`;

  return io(namespaceUrl, {
    auth: {
      token,
    },
    transports: ['websocket'],
    autoConnect: false,
  });
};

export const getChatSocket = (): Socket => {
  if (socket) {
    return socket;
  }

  socket = buildSocket();
  return socket;
};

export const resetChatSocket = (): void => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
